import { Box, SxProps } from '@mui/material';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Unstable_Grid2';
import { useTheme } from '@mui/styles';

import { Children } from '../../utils/reactTypes';

export const AxlePageHeader = ({
    title,
    description = '',
    children = null,
    sx,
}: {
    title: string;
    description?: string;
    children?: Children;
    sx?: SxProps;
}) => {
    const theme = useTheme();
    return (
        <Box mb={3} sx={sx}>
            <Grid container spacing={2} sx={{ justifyContent: 'space-between' }}>
                <Grid display={'flex'} alignItems={'center'}>
                    <Tooltip title={description} placement='right-end'>
                        <Typography variant='h1'>{title}</Typography>
                    </Tooltip>
                </Grid>
                <Grid xs={12} sm={'auto'}>
                    <Box
                        style={{
                            display: 'flex',
                            gap: theme.spacing(2),
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            // This helps visually align the title with any buttons:
                            paddingBottom: theme.spacing(1),
                        }}
                    >
                        {children}
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
};
